// Generated by CoffeeScript 1.12.7
define('root/app',['require','jquery','underscore','views/survey_view','sp/ui/alert','raven','etc/participant_cache','sp/locals','sp/utilities/get_query_string_parameter'],function(require) {
  var $, Alert, App, ParticipantCache, Raven, SurveyView, _, getQueryStringParameter, locals;
  $ = require('jquery');
  _ = require('underscore');
  SurveyView = require("views/survey_view");
  Alert = require('sp/ui/alert');
  Raven = require('raven');
  ParticipantCache = require('etc/participant_cache');
  locals = require('sp/locals');
  getQueryStringParameter = require('sp/utilities/get_query_string_parameter');
  return App = (function() {
    App.MAX_REQUESTS = 5;

    App.surveyView = null;

    App.prototype.dataFetchCount = 0;

    App.prototype.errRetryMill = 800;

    App.prototype.surveyId = null;

    App.prototype.session = null;

    function App(surveyId) {
      this.surveyId = surveyId || GLOBALS.surveyId;
      this.init();
    }

    App.prototype.init = function() {
      return this.getData((function(_this) {
        return function(data) {
          var language;
          _this.surveyView = new SurveyView({
            version: GLOBALS.version,
            env: GLOBALS.env,
            data: data
          });
          language = _.get(data, ['language', 'code']);
          _this.surveyView.on(SurveyView.UNAVAILABLE_EVENT, function() {
            _this.surveyView.destroyListeners();
            return window.location.href = "/unavailable?lang=" + language;
          });
          _this.surveyView.on(SurveyView.FORBIDDEN_EVENT, function() {
            _this.surveyView.destroyListeners();
            return window.location.href = "/completed?lang=" + language;
          });
          return _this.surveyView.render();
        };
      })(this));
    };

    App.prototype.getData = function(callback) {
      var args, preview, query, session, url;
      url = GLOBALS.uris.api + "/survey/data/" + this.surveyId;
      query = {};
      session = ParticipantCache.getSession(this.surveyId);
      preview = getQueryStringParameter('preview');
      if (preview && preview.length) {
        query.preview = preview;
      }
      args = {
        url: url,
        data: query,
        dataType: 'json',
        beforeSend: function(req) {
          if (session && session.length) {
            return req.setRequestHeader('x-session', session);
          }
        }
      };
      return $.ajax(args).done(function(res) {
        return callback(res.data);
      }).fail((function(_this) {
        return function(err) {
          var alert;
          _this.dataFetchCount++;
          if (_this.dataFetchCount < App.MAX_REQUESTS) {
            return setTimeout(function() {
              _this.errRetryMill /= 0.5;
              return _this.getData(callback);
            }, _this.errRetryMill);
          }
          Raven.captureException(err);
          alert = new Alert();
          alert.hideDelayTime = 0;
          alert.type = "error";
          alert.headline = "Unexpected Error";
          alert.message = "Please refresh the page and try again; if that \ndoesn't help <a href='https://surveyplanet.com/contact' \ntarget='_blank'>contact us</a>, we're happy to help.";
          return alert.render();
        };
      })(this));
    };

    return App;

  })();
});

